import * as Yup from 'yup';

export const ScheduleShema = Yup.object().shape({
    userId: Yup.string().required('f:validation.required'),
    name: Yup.string().required('f:validation.required'),
});
